import DoughnutChart from "components/charts/doughnut-chart/DoughnutChart";
import PieChart from "components/charts/pie-chart/PieChart";
import Widget from "components/widget/Widget";
import React from "react";

export default function EmployeeLeaveStatuses({ data }) {
  let ChartData = {
    labels: [],
    datasets: [
      {
        data: [],
        tension: 0,
      },
    ],
  };

  console.log(data);

  let labels = data?.map((item) => item?.status);
  // remove repeated labels
  ChartData.labels = [...new Set(labels)];

  // Count the number of time label repeated
  ChartData.labels.forEach((label) => {
    let count = 0;
    data.forEach((item) => {
      if (item?.status === label) {
        count++;
      }
    });
    ChartData.datasets[0].data.push(count);
  });

  return (
    <Widget heading={"Employee Leaves Statuses"}>
      <DoughnutChart labels={ChartData.labels} datasets={ChartData.datasets} />
    </Widget>
  );
}
